import React, { useEffect, useRef } from "react";
import "./aboutMe.css";
import { slideUD, fadeWordsOnScroll } from "../../animationGsap/Animation";

const Aboutme = () => {
  const heading = useRef(null);
  const body = useRef(null);

  useEffect(() => {
    slideUD(".heading");
    fadeWordsOnScroll("#para");
  }, []);

  const paragraph = `I’m a Graduate Engineering Trainee at HCLTech, contributing to enterprise
    banking applications. My work focuses on Java and Spring Boot microservices, customer
    onboarding and application workflows, and collaborating with web and mobile teams on backend
    changes. My professional experience is backend-focused, and I also have knowledge of frontend
    development with React and JavaScript. My experience includes SQL, Kafka, Kubernetes, and
    CI/CD. I began my journey at HCLTech as a Scholar, building foundations in backend development
    and software engineering. I enjoy solving problems and creating reliable, maintainable
    software.`;
  return (
    <div className="aboutMe">
      <div className="heading" ref={heading}>
        <h1>
          <span className="hi">Hi ,</span> This is{" "}
          <span style={{ color: "#2aebb4" }}>Dileep</span>!
        </h1>
      </div>
      <div className="aboutMeInfo" ref={body}>
        <h3>About Me :</h3>
        <p id="para">
          {paragraph.split(" ").map((word, i) => (
            <span key={i} className="word-wrapper">
              <span className="word">{word}</span>{" "}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
};

export default Aboutme;
